import { DynamoDBClient } from '../shared';
import { DEFAULT_DYNAMO_DB_CLIENT } from '../shared/aws/dynamodb';
import { validationBoom } from '../shared/rest';
import BaseService, { ServiceResponse } from '../shared/services';
import { FormErrorsBoom } from '../shared/validation/types';

import { DynamoUserDatasource, UserDatasource } from './db/datasource';
import { UserInfo } from './db/types';
import { validateCompleteGettingStartedTaskPayload } from './validation';

export class UserService extends BaseService {
  private datasource: UserDatasource;

  public constructor(dynamoClient: DynamoDBClient = DEFAULT_DYNAMO_DB_CLIENT) {
    super();
    this.datasource = new DynamoUserDatasource(dynamoClient);
  }

  public getUserInfo = (
    userId: string
  ): Promise<ServiceResponse<UserInfo | FormErrorsBoom<undefined>>> => {
    return this.tryExecute(async () => {
      const userInfo = await this.datasource.getUserInfo(userId);
      return this.serviceResponse(userInfo);
    });
  };

  public completeGettingStartedTask = async (
    userId: string,
    taskName: string
  ): Promise<ServiceResponse<UserInfo | FormErrorsBoom<undefined>>> => {
    const params = {
      userId,
      taskName,
      completedOn: new Date(),
    };

    const validationResponse = await validateCompleteGettingStartedTaskPayload(params);
    if (validationResponse.error) {
      return this.serviceResponseFromBoom(validationBoom(validationResponse.errors));
    }

    return this.tryExecute(async () => {
      const userInfo = await this.datasource.completeGettingStartedTask(params);
      return this.serviceResponse(userInfo);
    });
  };
}

const userService = new UserService();

export default userService;
